// Ported from sge_infantil_web/src/pages/dashboard/utils/StatisticUtils.ts (types dropped)
export default class StatisticUtils {
  static getTotals(statisticEntry) {
    const today = new Date();
    const todayString = today.toISOString().split('T')[0];

    const yesterday = new Date(today);
    yesterday.setDate(today.getDate() - 1);
    const yesterdayString = yesterday.toISOString().split('T')[0];

    const currentWeekStart = new Date(today);
    currentWeekStart.setDate(today.getDate() - today.getDay());

    const lastWeekStart = new Date(currentWeekStart);
    lastWeekStart.setDate(currentWeekStart.getDate() - 7);
    const lastWeekEnd = new Date(currentWeekStart);
    lastWeekEnd.setDate(currentWeekStart.getDate() - 1);

    const currentMonthStart = new Date(today.getFullYear(), today.getMonth(), 1);
    const lastMonthStart = new Date(today.getFullYear(), today.getMonth() - 1, 1);
    const lastMonthEnd = new Date(today.getFullYear(), today.getMonth(), 0);

    const getTotal = (start, end, key) =>
      statisticEntry
        .filter((entry) => {
          const entryDate = new Date(entry.date);
          return entryDate >= start && entryDate <= end;
        })
        .reduce((sum, entry) => sum + Number(entry[key] || 0), 0);

    const todayTotal = parseInt(
      statisticEntry.find((entry) => entry.date === todayString)?.count || '0',
      10,
    );
    const todayAmount = parseFloat(
      statisticEntry.find((entry) => entry.date === todayString)?.sum || '0',
    );
    const yesterdayTotal = parseInt(
      statisticEntry.find((entry) => entry.date === yesterdayString)?.count || '0',
      10,
    );

    const currentWeekTotal = getTotal(currentWeekStart, today, 'count');
    const lastWeekTotal = getTotal(lastWeekStart, lastWeekEnd, 'count');
    const currentMonthTotal = getTotal(currentMonthStart, today, 'count');
    const lastMonthTotal = getTotal(lastMonthStart, lastMonthEnd, 'count');
    const currentMonthAmount = getTotal(currentMonthStart, today, 'sum');

    const dailyVariation =
      yesterdayTotal === 0
        ? todayTotal > 0
          ? 100
          : 0
        : ((todayTotal - yesterdayTotal) / yesterdayTotal) * 100;

    const weeklyVariation =
      lastWeekTotal === 0
        ? currentWeekTotal > 0
          ? 100
          : 0
        : ((currentWeekTotal - lastWeekTotal) / lastWeekTotal) * 100;

    const monthlyVariation =
      lastMonthTotal === 0 ? 100 : ((currentMonthTotal - lastMonthTotal) / lastMonthTotal) * 100;

    return {
      todayTotal,
      todayAmount,
      yesterdayTotal,
      currentWeekTotal,
      lastWeekTotal,
      currentMonthTotal,
      currentMonthAmount,
      dailyVariation: parseFloat(dailyVariation.toFixed(2)),
      weeklyVariation: parseFloat(weeklyVariation.toFixed(2)),
      monthlyVariation: parseFloat(monthlyVariation.toFixed(2)),
    };
  }

  static getCountTotals(statisticEntry) {
    const today = new Date();
    const todayString = today.toISOString().split('T')[0];

    const yesterday = new Date(today);
    yesterday.setDate(today.getDate() - 1);
    const yesterdayString = yesterday.toISOString().split('T')[0];

    const currentWeekStart = new Date(today);
    currentWeekStart.setDate(today.getDate() - today.getDay());

    const lastWeekStart = new Date(currentWeekStart);
    lastWeekStart.setDate(currentWeekStart.getDate() - 7);
    const lastWeekEnd = new Date(currentWeekStart);
    lastWeekEnd.setDate(currentWeekStart.getDate() - 1);

    const currentMonthStart = new Date(today.getFullYear(), today.getMonth(), 1);
    const lastMonthStart = new Date(today.getFullYear(), today.getMonth() - 1, 1);
    const lastMonthEnd = new Date(today.getFullYear(), today.getMonth(), 0);

    const getTotal = (start, end, key) =>
      statisticEntry
        .filter((entry) => {
          const entryDate = new Date(entry.date);
          return entryDate >= start && entryDate <= end;
        })
        .reduce((sum, entry) => sum + Number(entry[key] || 0), 0);

    const todayTotal = parseInt(
      statisticEntry.find((entry) => entry.date === todayString)?.count || '0',
      10,
    );
    const yesterdayTotal = parseInt(
      statisticEntry.find((entry) => entry.date === yesterdayString)?.count || '0',
      10,
    );

    const currentWeekTotal = getTotal(currentWeekStart, today, 'count');
    const lastWeekTotal = getTotal(lastWeekStart, lastWeekEnd, 'count');
    const currentMonthTotal = getTotal(currentMonthStart, today, 'count');
    const lastMonthTotal = getTotal(lastMonthStart, lastMonthEnd, 'count');

    const dailyVariation =
      yesterdayTotal === 0
        ? todayTotal > 0
          ? 100
          : 0
        : ((todayTotal - yesterdayTotal) / yesterdayTotal) * 100;

    const weeklyVariation =
      lastWeekTotal === 0
        ? currentWeekTotal > 0
          ? 100
          : 0
        : ((currentWeekTotal - lastWeekTotal) / lastWeekTotal) * 100;

    const monthlyVariation =
      lastMonthTotal === 0 ? 100 : ((currentMonthTotal - lastMonthTotal) / lastMonthTotal) * 100;

    return {
      todayTotal,
      yesterdayTotal,
      currentWeekTotal,
      lastWeekTotal,
      currentMonthTotal,
      dailyVariation: parseFloat(dailyVariation.toFixed(2)),
      weeklyVariation: parseFloat(weeklyVariation.toFixed(2)),
      monthlyVariation: parseFloat(monthlyVariation.toFixed(2)),
    };
  }
}
